<template>
  <nav class="ai-visibility-table-pagination" aria-label="Table pagination">
    <button
      type="button"
      aria-label="Previous page"
      :disabled="disabled || page <= 1"
      @click="goToPage(page - 1)"
    >
      <i class="material-icons">chevron_left</i>
    </button>

    <button
      v-for="pageNumber in visiblePages"
      :key="pageNumber"
      type="button"
      :class="{ 'ai-visibility-table-pagination__page--active': pageNumber === page }"
      :disabled="disabled"
      @click="goToPage(pageNumber)"
    >
      {{ pageNumber }}
    </button>

    <button
      type="button"
      aria-label="Next page"
      :disabled="disabled || page >= pageCount"
      @click="goToPage(page + 1)"
    >
      <i class="material-icons">chevron_right</i>
    </button>
  </nav>
</template>

<script>
export default {
  name: 'TablePagination',
  props: {
    page: {
      type: Number,
      required: true,
    },
    pageCount: {
      type: Number,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    visiblePages () {
      const count = Math.max(0, this.pageCount)
      return Array.from({ length: count }, (item, index) => index + 1)
    },
  },
  methods: {
    goToPage (page) {
      if (this.disabled || page < 1 || page > this.pageCount || page === this.page) {
        return
      }
      this.$emit('input', page)
    },
  },
}
</script>

<style lang="scss" scoped>

.ai-visibility-table-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 32px;
}

.ai-visibility-table-pagination button {
  display: inline-flex;
  min-width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  color: var(--v-darkGrayColor-base);
  cursor: pointer;
  font-size: 16px;
  font-weight: 700;
  padding: 0 8px;
}

.ai-visibility-table-pagination button:disabled {
  cursor: default;
  opacity: 0.45;
}

.ai-visibility-table-pagination i {
  font-size: 20px;
}

.ai-visibility-table-pagination__page--active {
  background: var(--v-profileAnchorColor-base);
  color: var(--v-whiteColor-base) !important;
}
</style>
